export enum PlaceSubtype {
    nr1 = 1,
    AtputasVieta = 2,
    DabasTaka = 3,
    AktivaAtputa_VeloTaka = 4,
    DabasApskatesObjekts = 5,
    KulturvesturisksApskatesObjekts = 6,
    MammadabaGalamerki = 7,
    SkatuTornis = 9,
    AktivaAtputa_Orientesanas = 10,
    Udensturistiem = 11,
    MarsrutiIedvesmai = 40 // šī ir tikai lai filtru sarakstā maršrutus iekļautu
}
export enum CustomSubtype { // veido no PlaceSybtype + savs tipa identifikators
    Dizkoks = 51, // ietilpst DabasApskatesObjekts kategorijā, pirmais cipars ir 5
    Peldvieta = 21, // ietilpst AtputasVieta kategorijā, pirmais cipars ir 2
    Pilskalns = 61, // ietilpst KulturvesturisksApskatesObjekts kategorijā, pirmais cipars ir 6
    PasvaldibasObjekts = 1000 // šeit izmanto visas PlaceSubtype kategorijas, tāpat kā LVM objektiem
    // Velotaka = 101,
    // OrientesanasPolygon = 111
}
export enum CustomSubtypeOIDGap { // OBJECTID tiek palielināts par šo vērtību
    Dizkoks = 100000,
    Peldvieta = 200000,
    Pilskalns = 300000,
    PasvaldibasObjekts = 400000
}
export enum UserStatus {
    Default = 0,
    Visited = 1,
    Route = 2
}
export enum SelectedStatus {
    Default = 0,
    Selected = 1
}
export enum Filter {
    PLACESUBTYPE = "PLACESUBTYPE",
    VISITED = "VISITED",
    LIKE = "LIKE",
    ROUTE = "ROUTE",
    TOURISMTYPESSTR = "TOURISMTYPESSTR",
    LVREGION = "LVREGION",
    nearby = "nearby"
}

export enum Option {
    None = "none",
    IS = "IS",
    NOT = "NOT"
}
export enum RouteLayers {
    Route = "routeLayer",
    Other = "otherlayer",
    RoutePoints = "routePointsLayer",
    RouteTrack = "routeTrackLayer"
}

export enum FeatureType {
    LVMRecreationPlace = "LvmRecreationPlace",
    RouteOtherPlace = "RouteOtherPlace",
    RouteMainPoint = "RouteMainPoint",
    RouteTrack = "RouteTrack",
    RoutePoint = "RoutePoint",
    GameMainPoint = "GameMainPoint",
    GameCheckPoint = "GameCheckPoint",
    GameTrack = "GameTrack"
}

export enum RoutePointDataSource {
    LVM = 1,
    Other = 2
}

export enum GamePointStatus {
    Default = 0,
    Started = 1,
    Completed = 2
}

export enum TrackType {
    Velotaka = 22,
    Meztaka = 23,
    Jurtaka = 24,
    Ezertaka = 25,
    DabastakaParskata = 26,
    DabastakaVideja = 27,
    DabastakaMaza = 28
}

export enum LocationState {
    Inactive = "Inactive",
    Waiting = "Waiting",
    Watching = "Watching",
    Tracking = "Tracking"
}
